import { Location } from "@angular/common";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ColumnMode } from "@swimlane/ngx-datatable";
import { DownloadPdfRQ } from 'app/open-api/model/downloadPdfRQ';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DatePipe, CurrencyPipe } from '@angular/common';
import {
  AssigmentDealerModel,
  AssigmentService,
  CreateDealerBalanceRQ,
  DealerBalanceService,
  DealerModel,
  DealerService,
  ShippingListModel,
  ShippingService,
  FlightListModel,
  FlightService,
  BillService,
  ListFlightByShippingRQ
} from "app/open-api";
import domToImage from "dom-to-image";
import { environment } from "environments/environment";
import jsPDF, { jsPDFOptions } from "jspdf";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { ShippingListRQ } from '../../open-api/model/ShippingListRQ';
import * as XLSX from 'xlsx';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: "app-dealer-balance-create",
  templateUrl: "./dealer-balance-create.component.html",
  styleUrls: ["./dealer-balance-create.component.scss"],
  providers: [DatePipe, CurrencyPipe],
})
export class DealerBalanceCreateComponent implements OnInit {
  @ViewChild("tablePrint", { static: false }) dataToExport: ElementRef;
  public basicSelectedOption: number = 5;
  public searchForm: FormGroup;
  public shippings: ShippingListModel[] = [];
  public dealers: DealerModel[] = [];
  public assigments: AssigmentDealerModel[] = [];
  flights: FlightListModel[] = [];
  public ColumnMode = ColumnMode;
  createDealerBalance: CreateDealerBalanceRQ;
  isGeneratingMode = false;
  today: Date = new Date();
  currenciesResumen: any[] = [];
  totalPound: number = 0;
  urlApi = environment.apiUrl;

  constructor(
    private location: Location,
    private dealerService: DealerService,
    private spinner: NgxSpinnerService,
    private shippingService: ShippingService,
    private assigmentService: AssigmentService,
    private dealerbalanceService: DealerBalanceService,
    private router: Router,
    private billService: BillService,
    private _flightService: FlightService, 
    private datePipe: DatePipe,   
  ) {
    this.searchForm = new FormGroup({
      shippingId: new FormControl(null, Validators.required),
      dealerId: new FormControl(null, Validators.required),
      flightId: new FormControl(null),
    });
  }

  async ngOnInit(): Promise<void> {
    this.spinner.show();
    this.FetchFlights();
    await this.FetchModel();
    this.spinner.hide();
  }

  generatePDF() {
    this.spinner.show();
    const contenido: string[][] = [];
    const shippingId = this.searchForm.get("shippingId").value;
    const dealerId = this.searchForm.get("dealerId").value;
    const shipping = this.shippings.find(
      (shipping) => shipping.id === shippingId
    );
    const dealer = this.dealers.find((dealer) => dealer.id === dealerId);
    contenido.push([
      "#",
      "CÓDIGO",
      "PESO(LBS)",
      "PRECIO X LIBRA",
      "COMISIÓN",
      "MONEDA",
      "ESTADO",      
    ]);
    
    this.assigments.forEach((b, index) => {      
      contenido.push([
        (index + 1).toString(),
        b.billCode + " " + (b.serviceCode ?? ''),
        b.billPounds.toString(),
        b.price.toFixed(2),
        b.total.toString(),
        b.currencyName,
        b.billStateCatalogName,        
      ]);
    });
    const totalColumn: any[] = [];

    const documentDefinition = {
      pageOrientation: "landscape",
      pageSize: "LETTER",
      content: [
        {
          columns: [
            { text: "Repartidor: " +
              dealer.userName +
              ".  Envio: " +
              shipping.code +
              ".  Fecha del reporte: " +
              moment().format("ll"), style: ["title"], margin: [0, 10] },
          ],
        },
        {
          text: "PESO TOTAL (LBS): " +
          this.SummaryPounds() +
            ".  PRECIO TOTAL: " +
            this.SummaryTotal() +
            ".  COMISION TOTAL: " +
            this.SummaryDealerTotal(),          
          style: ["subtitle"],
          margin: [0, 10],
        },
        {
          layout: "lightHorizontalLines",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto"],
            body: contenido,
          },
        },
      ],
      styles: {
        title: {
          fontSize: 22,
          bold: true,
          alignment: "left",
        },
        title2: {
          fontSize: 12,
          bold: true,
          alignment: "right",
        },
        subtitle: {
          fontSize: 14,
          alignment: "left",
        },
        footer: {
          fontSize: 8,
          alignment: "right",
        },
      },
    };
    pdfMake.createPdf(documentDefinition).open();
    this.spinner.hide();
  }

  FetchFlights() {
    this._flightService.apiFlightListGet().subscribe((response) => {
      this.flights = response.list;      
    });
  }

  GetFlightByShippingId() {
    this.spinner.show();
    this.createDealerBalance = this.searchForm.value;
    if (this.searchForm.get("shippingId").value != null) {
      this.flights = [];
      const params: ListFlightByShippingRQ = {
        shippingId: +this.searchForm.get("shippingId").value,
      };
      this._flightService
        .apiFlightListByShippingPost(params)
        .subscribe((response) => {
          this.flights = response.list;
          this.spinner.hide();
        });
    } else {
      this.flights = [];
      this.spinner.hide();
    }
  }

  async FetchModel(): Promise<void> {
    const request: ShippingListRQ = {      
    }

    await this.dealerService
      .apiDealerListGet()
      .toPromise()
      .then((response) => {
        this.dealers = response.list;
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!. " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
      });
    await this.shippingService
      .apiShippingListGet(request)
      .toPromise()
      .then((response) => {        
        this.shippings = response.list;
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!. " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
      });
  }

  SearchAssigments() {
    this.spinner.show();
    this.assigmentService
      .apiAssigmentListAssigmentByShippingDealerPost(this.searchForm.value)
      .subscribe(
        (res) => {          
          this.assigments = res.list;
          this.basicSelectedOption = this.assigments.length;
          this.spinner.hide();
        },
        (error) => {
          Swal.fire({
            title: "Error!. " + error,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
            position: "top-end",
          });
          this.spinner.hide();
        }
      );
  }

  ValidateBillState() {
    var assigments = this.assigments.filter(
      (bill) => bill.billStateCatalogName !== "ENTREGADA"
    );
    return assigments.length > 0;
  }

  Back(): void {
    this.location.back();
  }

  GenerateBalance() {
    this.isGeneratingMode = true;
    this.createDealerBalance = this.searchForm.value;
    const dealer = this.dealers.find(
      (dealer) => dealer.id === this.createDealerBalance.dealerId
    );
    const shipping = this.shippings.find(
      (shipping) => shipping.id === this.createDealerBalance.shippingId
    );
    this.createDealerBalance.dealerName = dealer.userName;
    this.createDealerBalance.shippingCode = shipping.code;
    this.createDealerBalance.billsTotal = this.assigments.length;
    this.createDealerBalance.billIds = this.assigments.map(
      (assigment) => assigment.billId
    );
    this.createDealerBalance.billsCost = this.assigments.reduce(
      (accumulator, assigment) => {
        return accumulator + assigment.billTotal;
      },
      0
    );

    this.totalPound = this.assigments.reduce((accumulator, assigment) => {
      return accumulator + assigment.billPounds;
    }, 0);
    this.GroupBy(this.assigments);
    this.createDealerBalance.currenciesSummary = JSON.stringify(
      this.currenciesResumen
    );
  }

  AddBalance() {
    this.spinner.show();
    this.dealerbalanceService
      .apiDealerBalanceAddPost(this.createDealerBalance)
      .subscribe(
        (res) => {
          Swal.fire({
            title: "Cierre Creado",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            position: "top-end",
          });
          this.spinner.hide();
          this.router.navigate(["/pages/dealer-balance"]);
        },
        (error) => {
          Swal.fire({
            title: "Error!. " + error,
            icon: "error",
            showConfirmButton: false,
            timer: 2000,
            position: "top-end",
          });
          this.spinner.hide();
        }
      );
  }

  DownloadPdf(billId: number){
    this.spinner.show();
    const param: DownloadPdfRQ = {
      billId: billId
    }    
    this.billService.apiDownloadPdfPost(param).subscribe(response => {
      
      const fileURL = URL.createObjectURL(response);
      window.open(fileURL, '_blank');

      Swal.fire({
        title: `El pdf se descargó satisfactoriamente.`,
        icon: 'success',
        showConfirmButton: false,
        timer: 5000,
        position: 'top'
      });

      this.spinner.hide();
    }, error => {
      //console.warn(error);
      Swal.fire({
        title: 'Error! ' + error.error,
        icon: 'error',
        showConfirmButton: false,
        timer: 5000,
        position: 'top'
      });
      this.spinner.hide();
    });   
  
  }

  GroupBy(array: AssigmentDealerModel[]) {
    array.forEach((assigment) => {
      const currencyResumen = this.currenciesResumen.find(
        (resumen) => resumen.currencyId === assigment.currencyId
      );
      if (currencyResumen) {
        currencyResumen.currencyTotal += assigment.total;
      } else {
        this.currenciesResumen.push({
          currencyId: assigment.currencyId,
          currencyName: assigment.currencyName,
          currencyTotal: assigment.total,
        });
      }
    });
  }

  SummaryPounds() {
    return this.assigments.reduce((a, b) => a + b.billPounds, 0);
  }

  SummaryTotal() {
    return this.assigments.reduce((a, b) => a + b.price, 0);
  }

  SummaryDealerTotal() {
    return this.assigments.reduce((a, b) => a + b.total, 0);
  }

  GetURLById(id: number) {
    const bill = this.assigments.find((b) => b.id === id);
    return this.urlApi + "/Bills/" + bill.billFile;
  }

  GetCodeById(id: number) {
    const bill = this.assigments.find((b) => b.billId === id);
    return bill.billCode;
  }

  printTable() {
    this.spinner.show();
    const width = this.dataToExport.nativeElement.clientWidth;
    const height = this.dataToExport.nativeElement.clientHeight + 80;
    const shippingId = this.searchForm.get("shippingId").value;
    const dealerId = this.searchForm.get("dealerId").value;
    const shipping = this.shippings.find(
      (shipping) => shipping.id === shippingId
    );
    const dealer = this.dealers.find((dealer) => dealer.id === dealerId);
    domToImage
      .toPng(this.dataToExport.nativeElement, {
        width: width,
        height: height,
      })
      .then((result) => {
        let jsPdfOptions: jsPDFOptions = {
          orientation: width > height ? "l" : "p",
          unit: "pt",
          format: [width + 50, height + 220],
        };
        const pdf = new jsPDF(jsPdfOptions);
        pdf.addImage(result, "PNG", 25, 185, width, height);
        pdf.setFontSize(16);
        pdf.setTextColor("#131523");
        pdf.text(
          "Repartidor: " +
            dealer.userName +
            ". Envio: " +
            shipping.code +
            ". Fecha del reporte: " +
            moment().format("ll"),
          25,
          115
        );
        pdf.save(
          dealer.userName +
            "-" +
            shipping.code +
            "-" +
            moment().format("yyyyMMDD") +
            ".pdf"
        );
        this.spinner.hide();
      })
      .catch((error) => {
        this.spinner.hide();
      });
  }
}
